import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { UserActions } from "../../../redux/actions/user.actions";
import { translationConstants } from "../../../constants";

const CancelButton = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  return (
    <p
      onClick={() => {
        dispatch(UserActions.OpenModal(false));
      }}
      className="Cancel-button"
      type="submit"
    >
      {t(translationConstants.cancel)}
    </p>
  );
};

export default CancelButton;
